<template>
    <div
        class="challenge"
        :style="{ backgroundImage: `url('${props.cardItem.bgImage}')` }"
        @mouseenter="onMouseover"
        @mouseleave="onMouseleave"
    >
        <div class="challenge-title" v-html="$t(cardItem.title)"></div>
        <div class="challenge-blue" ref="BlueRef">
            <div>
                <div class="blue-title" v-html="$t(cardItem.title)"></div>
                <div class="blue-follow" v-html="$t(cardItem.follow)"></div>
            </div>
            <div>
                <div class="blue-svg">
                    <img src="@assets/imgs/Solutions/Brand/Swipper/transparentArrow.png" alt="" />
                </div>
                <div class="blue-text">
                    <span v-html="$t(cardItem.text)"></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { gsap } from 'gsap';
    import { ScrollTrigger } from 'gsap/all';
    import { ref } from 'vue';
    import { matchMobile } from '~~/composables/useMatchRules.ts';

    gsap.registerPlugin(ScrollTrigger);
    const BlueRef = ref(null);
    const isMobile = ref<Boolean>(false);

    interface CardItemData {
        title: String;
        follow: String;
        text: String;
        bgImage: String;
    }
    // const props = defineProps<{
    //     cardItem: CardItemData;
    // }>();
    const props = withDefaults(
        defineProps<{
            reverse?: boolean; // 翻转方向是否反转
            backgroundImage?: string;
            hideArrow?: boolean;
            cardItem: CardItemData;
        }>(),
        {
            reverse: false,
            hideArrow: false,
        },
    );

    const onMouseover = () => {
        gsap.timeline().to(BlueRef.value, {
            y: -BlueRef.value.offsetHeight,
            opacity: 1,
            duration: 0.5,
            textShadow: 'none',
            ease: 'none',
        });
    };
    const onMouseleave = () => {
        gsap.timeline().to(BlueRef.value, {
            y: BlueRef.value.offsetHeight,
            opacity: 0,
            duration: 0.5,
            textShadow: 'none',
            ease: 'none',
        });
    };

    onBeforeMount(() => {
        isMobile.value = matchMobile();
    });
</script>

<style lang="less" scoped>
    .challenge {
        width: .convert(325px) [ @vw];
        height: .convert(416px) [ @vw];
        border-radius: .convert(20px) [ @vw];
        position: relative;
        overflow: hidden;
        &:hover {
            background-image: unset !important;
            background-color: blue;
            transition: 0.5s;
            .challenge-title {
                display: none;
            }
        }

        &-title {
            width: .convert(224px) [ @vw];
            position: absolute;
            bottom: .convert(24px) [ @vw];
            left: .convert(24px) [ @vw];
            text-shadow: 0px 0px 60px #3a3a3a;
            color: #fff;
            font-size: .convert(48px) [ @vw];
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            font-family: 'HarmonyOS Sans SC';
        }
        &-blue {
            width: 100%;
            height: 100%;
            border-radius: .convert(20px) [ @vw];
            padding: .convert(27px) [ @vw].convert (21px) [ @vw].convert (20px) [ @vw].convert (24px) [ @vw];
            font-style: normal;
            line-height: normal;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            position: absolute;
            top: 100%;
            opacity: 0;
            font-family: 'HarmonyOS Sans SC';

            .blue-title {
                color: #fff;
                font-style: normal;

                font-size: .convert(38px) [ @vw];
                font-weight: 400;
            }
            .blue-follow {
                color: #fff;
                font-size: .convert(16px) [ @vw];
                font-weight: 400;
                margin-top: .convert(16px) [ @vw];
            }
            .blue-svg {
                display: flex;
                justify-content: center;
            }
            .blue-text {
                margin-top: .convert(20px) [ @vw];
                background-color: #fff;
                height: .convert(102px) [ @vw];
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: .convert(20px) [ @vw];
                span {
                    text-align: center;
                    color: #000;
                    font-size: .convert(32px) [ @vw];
                    font-weight: 400;
                }
            }
        }
    }

    :lang(en) {
        .challenge-title {
            font-family: Montserrat;
        }
        .challenge-blue {
            font-family: Montserrat;
        }
    }
</style>
